import { render, staticRenderFns } from "./Waitinglist.vue?vue&type=template&id=70e58ef2&"
import script from "./Waitinglist.vue?vue&type=script&lang=js&"
export * from "./Waitinglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports